// extracted by mini-css-extract-plugin
export default {"root":"ReportContentModal_root__t09G1","container":"ReportContentModal_container__u7iXg","body":"ReportContentModal_body__kTSvX"};